import React from 'react';

interface BtnCellRendererProps {
  text: any;
  clicked: () => void;
}

const BtnCellRenderer: React.FC<BtnCellRendererProps> = ({ text, clicked }) => {
  const btnClickedHandler = () => {
    clicked();
  };

  return (
    <button className='btn btn-sm btn-success' onClick={btnClickedHandler}>{text}</button>
  );
};

export default BtnCellRenderer;
